import Vue from 'vue';

export default Vue.extend({
  name: 'jobAttachUpload',
  props: ['taskId'],
  data () {
    return {
      Request: {
        FullFileName: '',
      },
      fileType: '',
      upload: false,
      uploaded: false,
      isFailed: false,
    };
  },
  methods: {
    /**
         * This method uploads the file to the server
         * Please, check its working. Make validation uploaded file formats
         * through through files extensions.
         * Please, make view of this template more user friendly
         * If you want to learn more about the work logic, please chek the
         * ProjectPackageController
         */
    FileUploadedHeandler (event) {
      var file = event.target.files;
      var uploadedObject = {
        fileInBlob: file[0],
        taskIx: this.taskId,
        fileName: file[0].name,
      };
      this.$emit('fileUploaded', uploadedObject);
    },

    /**
         * This method should delete file from server
         * if user wants change current file
         * Request Url /removeUploadedFile
         * You should pass to server Request Project (check structure on Post Data)
         * with FullFileName string.
         */
    DeleteUploadedFile () {
      // this.Request.FullFileName = this.doc.FullFileName;
      // var fileData = {
      //     Request: {
      //         FullFileName: this.doc.FullFileName,
      //     }};
      // axios.post(this.$store.getters.rootAPI + '/removeUploadedFile', fileData).then((response) => {
      //     this.uploaded = false;
      //     this.upload = false;
      //     this.doc.FullFileName = this.project.ProjectGroupPackage.FullFileName;
      //     this.doc.DownloadLink = '';
      // });
    },
  },
  mounted () {
    // this.fileType = '.' + this.doc.FileType;
  },
});
